import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { memo, useEffect, useRef, useState } from 'react';
import cc from 'classcat';
import PropTypes from 'prop-types';
import css from './ShareButton.module.scss';
import Link from '../../../components/icons/Link';
import Share from '../../../components/icons/Share';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var ShareButton = /*#__PURE__*/memo(function (_ref) {
  var centered = _ref.centered,
      id = _ref.id;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      copying = _useState2[0],
      setCopying = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      copied = _useState4[0],
      setCopied = _useState4[1];

  var copyRef = useRef(null);
  var inputRef = useRef(null);
  var shareRef = useRef(null);

  var onCopying = function onCopying() {
    setCopying(true);
  };

  var onCopy = function onCopy() {
    var _navigator$clipboard;

    var current = inputRef.current;
    /* Select the text field */

    current.select();
    current.setSelectionRange(0, 99999);
    /* For mobile devices */

    /* Copy the text inside the text field */

    (_navigator$clipboard = navigator.clipboard) === null || _navigator$clipboard === void 0 ? void 0 : _navigator$clipboard.writeText(current.value);
    setCopied(true);
  };

  useEffect(function () {
    if (!copied) {
      return;
    }

    var reset = function reset() {
      setCopying(false);
      setTimeout(function () {
        var _shareRef$current;

        setCopied(false);
        (_shareRef$current = shareRef.current) === null || _shareRef$current === void 0 ? void 0 : _shareRef$current.focus();
      }, 1000);
    };

    var timeout = setTimeout(reset, 3000);
    return function () {
      clearTimeout(timeout);
    };
  }, [copied]);
  useEffect(function () {
    var _copyRef$current;

    if (!copying) {
      return;
    }

    (_copyRef$current = copyRef.current) === null || _copyRef$current === void 0 ? void 0 : _copyRef$current.focus();
  }, [copying]);
  return /*#__PURE__*/_jsxs("div", {
    className: cc([css.root, _defineProperty({}, css.centered, centered)]),
    children: [/*#__PURE__*/_jsxs("div", {
      className: cc([css.copy, _defineProperty({}, css.on, copying)]),
      children: [/*#__PURE__*/_jsx("input", {
        className: css.input,
        readOnly: true,
        ref: inputRef,
        tabIndex: copying ? 0 : -1,
        type: "text",
        value: "https://www.outdoorvoices.com/pages/wish-lists?id=".concat(id)
      }), ' ', copied && /*#__PURE__*/_jsx("div", {
        className: css.copied,
        children: "Link Copied!"
      }), !copied && /*#__PURE__*/_jsxs("button", {
        "aria-label": "Click to copy the link to your clipboard",
        className: css.button,
        onClick: onCopy,
        ref: copyRef,
        tabIndex: copying ? 0 : -1,
        type: "button",
        children: [/*#__PURE__*/_jsx(Link, {}), " ", /*#__PURE__*/_jsx("span", {
          children: "Copy Link"
        })]
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: cc([css.share, _defineProperty({}, css.off, copying)]),
      children: /*#__PURE__*/_jsxs("button", {
        "aria-label": "Click to get a link for sharing your wish list",
        className: css.button,
        onClick: onCopying,
        ref: shareRef,
        tabIndex: copying ? -1 : 0,
        type: "button",
        children: [/*#__PURE__*/_jsx(Share, {}), " ", /*#__PURE__*/_jsx("span", {
          children: "Share"
        })]
      })
    })]
  });
});
ShareButton.propTypes = {
  centered: PropTypes.bool,
  id: PropTypes.string.isRequired
};
export default ShareButton;